exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nimg[data-v-4497bc28] {\n    width: 2rem;\n}\n", ""]);

